
import { handleActions } from 'redux-actions'
import {
  audioChatStartRequest,
  audioChatStartRequestCancel,
  audioChatResetPeerStatus,
  audioChatStartResponse,
  audioChatStarted,
  audioChatEnd,
  audioChatMuteMicrophone,
  audioChatPeerMicrophoneMuted,
  selectAudioInput,
  silenceAudio,
  audioChatStats,
} from './../actions/media'
import { APP_STEP, step } from './../actions/app'
// import { logger } from './../lib/utils/logger'

const stats = {
  audioLevel: 0,
  audioLevelPeer: 0,
}

const initialState = {
  chatRequest: false,
  requestByPeer: false,
  cancelByPeer: false,
  rejectByPeer: false,
  chatStarted: false,
  chatStartedByPeer: false,
  endByPeer: false,
  selectedAudioInput: null,
  restartStatus: {
    started: false,
    byPeer: false,
    chatRequest: false,
    requestByPeer: false,
    microphoneMuted: false,
  },
  microphoneMuted: false,
  peerMicrophoneMuted: false,
  silenceAudio: {
    context: null,
    stream: null,
    track: null,
  },
  stats,
}

export const audioReducer = handleActions({
  [audioChatStartRequest] (prevState, action) {
    const { requestByPeer } = action.payload
    return {
      ...prevState,
      chatRequest: true,
      cancelByPeer: false,
      requestByPeer,
    }
  },
  [audioChatStartRequestCancel] (prevState, action) {
    const { cancelByPeer } = action.payload
    return {
      ...prevState,
      chatRequest: false,
      requestByPeer: false,
      cancelByPeer,
      restartStatus: { ...initialState.restartStatus },
    }
  },
  [audioChatResetPeerStatus] (prevState, action) {
    return {
      ...prevState,
      ...action.payload,
    }
  },
  [audioChatStartResponse] (prevState, action) {
    const { fromPeer, response } = action.payload
    return {
      ...prevState,
      chatRequest: false,
      requestByPeer: false,
      rejectByPeer: (fromPeer && !response),
      restartStatus: { ...initialState.restartStatus },
    }
  },
  [audioChatStarted] (prevState) {
    return {
      ...prevState,
      chatStarted: true,
      chatStartedByPeer: prevState.requestByPeer,
      restartStatus: { ...initialState.restartStatus },
      microphoneMuted: false,
      peerMicrophoneMuted: false,
    }
  },
  [audioChatEnd] (prevState, action) {
    const { endByPeer = false, restart = false } = action.payload || {}
    return {
      ...prevState,
      requestByPeer: false,
      cancelByPeer: false,
      rejectByPeer: false,
      chatStarted: false,
      chatStartedByPeer: false,
      restartStatus: restart ? { ...prevState.restartStatus } : { ...initialState.restartStatus },
      microphoneMuted: false,
      peerMicrophoneMuted: false,
      endByPeer,
      stats,
    }
  },
  [audioChatMuteMicrophone] (prevState, action) {
    return {
      ...prevState,
      microphoneMuted: Boolean(action.payload),
    }
  },
  [audioChatPeerMicrophoneMuted] (prevState, action) {
    return {
      ...prevState,
      peerMicrophoneMuted: Boolean(action.payload),
    }
  },
  [selectAudioInput] (prevState, action) {
    return {
      ...prevState,
      selectedAudioInput: action.payload ? { ...action.payload } : null,
    }
  },
  [silenceAudio] (prevState, action) {
    const { context, stream, track } = action.payload
    return {
      ...prevState,
      silenceAudio: { context, stream, track },
    }
  },
  [audioChatStats] (prevState, action) {
    return {
      ...prevState,
      stats: { ...action.payload },
    }
  },
  [step] (prevState, action) {
    if (action.payload === APP_STEP.RTC_RESTARTING) {
      return {
        ...prevState,
        restartStatus: {
          started: prevState.chatStarted,
          byPeer: prevState.chatStartedByPeer,
          chatRequest: prevState.chatRequest,
          requestByPeer: prevState.requestByPeer,
          microphoneMuted: prevState.microphoneMuted,
        },
      }
    }
    if (action.payload === APP_STEP.RTC_START) {
      return {
        ...initialState,
        restartStatus: { ...prevState.restartStatus },
        silenceAudio: { ...prevState.silenceAudio }
      }
    }
    return prevState
  },
}, initialState)
